export default __webpack_public_path__ + "static/media/litecoin.e710ec56.png";